import { Plus } from "lucide-react";
import React, { useState } from "react";

export default function GenerateVoucher({ generateVouchers, isGenerating }) {
  const [numberOfVouchers, setNumberOfVouchers] = useState(0);
  const [voucherValue, setVoucherValue] = useState(0);
  const [prefix, setPrefix] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    await generateVouchers(numberOfVouchers, voucherValue, prefix);
    setNumberOfVouchers(0);
    setVoucherValue(0);
    setPrefix("");
  }
  return (
    <React.Fragment>
      <div className="generator-section">
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Generate Vouchers</h2>
          </div>
          <div className="card-content">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="prefix" className="form-label">
                  Voucher Prefix
                </label>
                <input
                  type="text"
                  id="prefix"
                  className="form-input"
                  value={prefix}
                  onChange={(e) => setPrefix(e.target.value)}
                  placeholder="GAME"
                />
                <p className="form-hint">
                  Format will be: {prefix || "GAME"}-XXXX-XXXX
                </p>
              </div>

              <div className="form-group">
                <label htmlFor="number" className="form-label">
                  Number of Vouchers
                </label>
                <input
                  type="number"
                  id="number"
                  className="form-input"
                  min="1"
                  max="1000"
                  value={numberOfVouchers}
                  onChange={(e) =>
                    setNumberOfVouchers(Number.parseInt(e.target.value))
                  }
                />
              </div>

              <div className="form-group">
                <label htmlFor="value" className="form-label">
                  Value per Voucher (€)
                </label>
                <input
                  type="number"
                  id="value"
                  className="form-input"
                  min="1"
                  value={voucherValue}
                  onChange={(e) =>
                    setVoucherValue(Number.parseInt(e.target.value))
                  }
                />
              </div>

              <button
                type="submit"
                className="generate-btn"
                disabled={isGenerating}
              >
                {isGenerating ? (
                  <>
                    <div className="spinner"></div>
                    Generating...
                  </>
                ) : (
                  <>
                    <Plus className="icon" />
                    Generate Vouchers
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
